/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'upload': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M3.3 29c1.27 0 2.3 1.007 2.3 2.25v9c0 .597.242 1.169.674 1.591A2.326 2.326 0 0 0 7.9 42.5h32.2c.61 0 1.195-.237 1.626-.659.432-.422.674-.994.674-1.591v-9c0-1.243 1.03-2.25 2.3-2.25 1.27 0 2.3 1.007 2.3 2.25v9c0 1.79-.727 3.507-2.021 4.773A6.979 6.979 0 0 1 40.1 47H7.9a6.979 6.979 0 0 1-4.879-1.977A6.677 6.677 0 0 1 1 40.25v-9C1 30.007 2.03 29 3.3 29zM22.468 1.711c.846-.948 2.218-.948 3.064 0l10.833 12.143c.846.949.846 2.486 0 3.435-.846.948-2.218.948-3.064 0L24 6.863 14.699 17.29c-.846.948-2.218.948-3.064 0-.846-.949-.846-2.486 0-3.435L22.468 1.711z"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M24 1c1.105 0 2 1.023 2 2.286v27.428C26 31.977 25.105 33 24 33s-2-1.023-2-2.286V3.286C22 2.023 22.895 1 24 1z"/>'
  }
})
